<template>
	<div class="footer flex">
		<div class="footer_content">
			<div class="content">
				<div class="flex">
					<p style="height: 80px;" class="content_top_title">{{ $t('footer.followUs') }}</p>
          <div class="flex content_img">
            <img class="item" src="https://ddlg-zhongtai-dev-1257088705.cos.ap-guangzhou.myqcloud.com/project/64725a26-2910-4293-9c6b-b437d5cc013f.png "/>
            <img class="link" src="https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/1e82fc36-991a-4aba-b2bb-df6f27cf305d.jpg" alt="">
            <img class="item" src=" https://ddlg-zhongtai-dev-1257088705.cos.ap-guangzhou.myqcloud.com/project/02ee46e1-84fd-4dd7-b295-bb2a68033694.png"/>
            <img class="link" src="https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/douyin_link.png" alt="">
            <a href="https://weibo.com/u/7307149621" target="_blank" >
              <img class="item" src="https://ddlg-zhongtai-dev-1257088705.cos.ap-guangzhou.myqcloud.com/project/0203359f-1b93-43e9-90da-dd80df90d8c9.png"/>
            </a>
          </div>
<!--					<ul class="flex" style="height: 80px; line-height: 80px;">-->
<!--						<li @click="toLink('https://ddlg.din-job.com/')">叮叮灵工</li>-->
<!--						<li @click="toLink('https://www.xchr-group.com/productService/lab.html')">产品服务</li>-->
<!--						&lt;!&ndash; <li>培训考证</li>-->
<!--						<li>灵工保险</li>-->
<!--						<li>法律援助</li> &ndash;&gt;-->
<!--					</ul>-->
				</div>
				<div class="flex center_content">
          <div class="center_item">
					<div class="title" style="height: 60px; line-height: 60px;">{{ $t('footer.recruit') }}</div>
            <div>
              <p @click="toitemLink(1)">{{ $t('footer.socialRecruit') }}</p>
              <p @click="toitemLink(2)">{{ $t('footer.talentPool') }}</p>
            </div>
          </div>
          <div  class="center_item"  >
            <div class="title" style="height: 60px; line-height: 60px;">{{ $t('footer.contact') }}</div>
            <div>
              <p @click="toitemLink(3)">{{ $t('footer.map') }}</p>
<!--              <p>在线留言</p>-->
              <p @click="toitemLink(4)">{{ $t('footer.branch') }}</p>
            </div>
          </div>
          <div  class="center_item" >
          <div  class="title" style="height: 60px; line-height: 60px;">{{ $t('footer.legal') }}</div>
          <div>
            <p @click="toitemLink(5)">{{ $t('footer.agreement') }}</p>
            <p @click="toitemLink(6)">{{ $t('footer.privacy') }}</p>
          </div>
        </div>
				</div>
			</div>
        <div class="right">
            <div class="form">
             <div class="form_item">
               <label for="footer_name">{{ $t('footer.name') }}</label>
               <input v-model="form.name" type="text" id="footer_name" class="name">
             </div>
              <div class="form_item">
                <label for="footer_name">{{ $t('footer.email') }}</label>
                <input v-model="form.email" type="text" id="footer_name" class="name">
              </div>
            </div>
          <div class="content_text">
<!--            <label for="footer_remark">请把您的需求留下，我们为您提供专业的解决方案</label>-->
            <textarea v-model="form.remark" rows="5" cols="30"  :placeholder="$t('footer.demandPlaceholder')"/>
            <button class="submitBtn" @click="submit">{{ $t('footer.submit') }}</button>
          </div>
        </div>
		</div>
	</div>
</template>

<script>
	import Header from "@/components/layout/header"
	import Footer from "@/components/layout/footer"
	import { addCollaborator } from "@/api/collaborator"
	export default {
		components: {
			Header, Footer
		},
		data() {
			return {
        form:{},
        linkList:{
          1:'https://www.xchr-group.com/joinus.html',
          2:'https://www.xchr-group.com/joinus.html',
          3:'https://www.xchr-group.com/contact.html#map',
          4:'https://www.xchr-group.com/contact.html#company',
          5:'https://www.xchr-group.com/service.html',
          6:'https://www.xchr-group.com/private.html',
        }
			}
		},
		methods: {
      submit(){
       if(!this.form.name){
         this.$message({
           message: this.$t('footer.validateName'),
           type: 'warning'
         });
         return
       }
       if(!this.form.email){
         this.$message({
           message: this.$t('footer.validateEmail') || '请输入邮箱',
           type: 'warning'
         });
         return
       }
       if(!this.form.remark){
         this.$message({
           message: this.$t('footer.validateRemark'),
           type: 'warning'
         });
         return
       }
        addCollaborator({
          name: this.form.name,
          email: this.form.email,
          remark: this.form.remark
        }).then((res) => {
          if(res.data.code==200){
            this.$message({
              message: this.$t('footer.submitSuccess'),
              type: 'success'
            });
            for (const obj in this.form) {
              this.form[obj] = '';
            }
          }else{
            this.$message({
              message: this.$t('footer.submitError'),
              type: 'error'
            });
          }

        }).catch(() => {
          this.$message({
            message: this.$t('footer.submitError'),
            type: 'error'
          });
        });
        console.log('tijiao')
      },
      toitemLink(type){
				window.open(this.linkList[type])
			}
		},

	}
</script>
<style scoped lang="scss">
	.footer{
		height: 320px;
		width: 100%;
		background-color: #fff;
			border-top: 1px solid #eee;
    padding-bottom: 70px;
		.footer_content{
			width: 65vw;
			height: 260px;
			margin: 0 auto;
			box-sizing: border-box;
			padding: 60px 0 30px;
			display: flex;
			justify-content: space-between;
			position: relative;
			.logo{
				position: absolute;
				left: -230px;
				top: 120px;
				p{
					margin-top: 20px;
					color: #1C51A3;
				}
			}
			.content{
				padding-left: 20px;

        .content_img{
          .item{
            width: 26px;
            height: 26px;
            margin-left: 30px;
            position: relative;
          }
          .link{
            display: none;
          }
          .item:hover{
            cursor: pointer;
          }
          .item:hover + .link{
            position: absolute;
            top:100px;
            display: block;
            width: 120px;
            height: 120px;

          }
        }
				.content_top_title{
					color:  #333;
					font-size: 20px;
          font-weight: 550;
					margin-right: 20px;
					vertical-align: middle;
				}
				ul{
					font-size: 18px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #999999;
					line-height: 28px;
					li{
						margin-left: 30px;
					}
					li:hover{
						color: #1C51A3;
						cursor: pointer;
					}
				}
        .center_content{
          flex-wrap: wrap;

          .center_item{
            margin-right: 136px;
            min-width: 100px;
          }
          .title{
            text-align: left;
            font-weight: 500;
            font-size: 20px;
            color: #666666;
            margin-bottom: 10px;
          }
          p{
            color: #666;
            font-size: 16px;
            text-align: left;
            margin-bottom: 20px;
            margin-right: 20px;
          }
          p:hover{
            font-weight: 700;
            color: #1C51A3;
            cursor: pointer;
          }
        }
			}
		}
    .right{

        display: flex;
      width: 25vw;
      .form{
          //width: 300px;
        .form_item{
          text-align: left;
          padding: 5px 5px 5px 10px;
          margin-bottom: 10px;
          width: 253px;
          font-size: 14px;
          height: 52px;
          line-height: 52px;
          background: #F0F0F0;
          border-radius: 8px;
          border: 1px solid #F7F7F7;
          label{
            color: #929292;
            text-align: left;
          }
          input{
            background: #F0F0F0;
            height: 30px;
            border: none;
            padding-left: 1ch;
          }

        }
      }
      .content_text{
        width: 253px;
        height: 200px;
        padding: 0 8px 10px 8px;
        textarea{
          resize: none;
          font-size: 14px;
          padding: 15px 16px;
          width: 255px;
          height: 116px;
          border: 1px solid #f0f0f0;
          background-color: #f0f0f0;
          overflow: hidden;
        }
        .submitBtn{
          width: 96px;
          height: 32px;
          background: #1C51A3;
          border-radius: 8px;
          margin-bottom: 40px;
          color:#fff;
          border: none;
          font-size: 16px;
          margin-left: 193px;
          margin-top: 20px;
        }
      }
    }
	}

</style>
